<template>
  <v-card outlined>
    <v-card flat>
      <v-card-title>
        {{ rating.semester.number }} семестр {{ rating.semester.name }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-text-field
              type="number"
              v-model="model.base"
              label="Размер базовой стипендии"
            />
          </v-col>
          <v-col cols="4">
            <v-switch
              v-model="model.showPoints"
              :true-value="true"
              :false-value="false"
              label="Отображать утвержденные баллы"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3">
            <v-switch
              v-model="model.showSum"
              :true-value="true"
              :false-value="false"
              label="Отображать сумму"
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="primary" @click="update">Сохранить</v-btn>
        <v-btn text color="success" @click="upload">Выгрузить (.xlsx)</v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>

<script>
import { updateRating, ratingReport } from "../../services/rating.service";
import { downloadRatingData } from "../../services/ratingExport.service";
export default {
  name: "RatingEditor",

  props: {
    rating: { type: Object, required: true }
  },

  components: {},

  data() {
    return {
      model: { ...this.rating }
    };
  },

  computed: {},

  mounted() {},

  methods: {
    async update() {
      try {
        await updateRating(this.rating.id, this.model);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
      this.$emit("update");
    },
    async upload() {
      try {
        await downloadRatingData(
          this.rating.id,
          `${this.rating.semester.number} семестр ${this.rating.semester.name}.xlsx`
        );
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    }
  }
};
</script>
